import { ButtonBlockComponent } from './blocks/ButtonBlock'
import { CheckboxBlockComponent } from './blocks/CheckboxBlock'
import { ContainerBlockRuntimeComponent } from './blocks/ContainerBlockRuntime'
import { DividerBlockComponent } from './blocks/DividerBlock'
import { DropdownBlockComponent } from './blocks/DropdownBlock'
import { GridBlockRuntimeComponent } from './blocks/GridBlockRuntime'
import { ImageBlockComponent } from './blocks/ImageBlock'
import { ListBlockRuntimeComponent } from './blocks/ListBlockRuntime'
import { MarkdownEditorBlockComponent } from './blocks/MarkdownEditorBlock'
import { MarkdownPreviewBlockComponent } from './blocks/MarkdownPreviewBlock'
import { NumberInputBlockComponent } from './blocks/NumberInputBlock'
import { ParagraphBlockComponent } from './blocks/ParagraphBlock'
import { RadioBlockComponent } from './blocks/RadioBlock'
import { TabsBlockRuntimeComponent } from './blocks/TabsBlockRuntime'
import { TextAreaBlockComponent } from './blocks/TextAreaBlock'
import { TextInputBlockComponent } from './blocks/TextInputBlock'
import { ToggleBlockComponent } from './blocks/ToggleBlock'
import { VideoBlockComponent } from './blocks/VideoBlock'
import { SegmentedVideoBlockComponent } from './blocks/SegmentedVideoBlock'

export const coreBlockComponents = [
    {
        type: 'button',
        component: ButtonBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'container',
        component: ContainerBlockRuntimeComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'grid',
        component: GridBlockRuntimeComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'list',
        component: ListBlockRuntimeComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'divider',
        component: DividerBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'textInput',
        component: TextInputBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'textArea',
        component: TextAreaBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'markdownEditor',
        component: MarkdownEditorBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'markdownPreview',
        component: MarkdownPreviewBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'numberInput',
        component: NumberInputBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'radio',
        component: RadioBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'checkbox',
        component: CheckboxBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'dropdown',
        component: DropdownBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'toggle',
        component: ToggleBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'image',
        component: ImageBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'video',
        component: VideoBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'segmentedVideo',
        component: SegmentedVideoBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'paragraph',
        component: ParagraphBlockComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
    {
        type: 'tabs',
        component: TabsBlockRuntimeComponent,
        schema: {
            state: {},
            methods: {},
        },
    },
]
